import React from 'react';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import PropTypes from 'prop-types';
import '../reset.css';
import styles from './index.css';

import GoTop from './goTop';
import Header from './header';
import Navigation from './nav';
import Banner from './banner';
import SimpleSlider from './slide';
import HotNews from './hotNews';
import Weixin from './wxList';
// import StockBox from './stockBox';
import NewsList from './newsList';
import Footer from './footer';

class Layout extends React.PureComponent {
    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const headerData = {
            nav: content.nav,
            logo: content.logo,
        };
        const footerData = {
            copyright: content.copyright,
        };

        return (
            <div>
                <Header content={headerData} />

                <Banner content={content.banner} />
                <Navigation content={content.navigation} />

                <div className={`${styles.con} clearfix`}>
                    <div className={styles.conL}>
                        {/* <StockBox content={content.stockCode} /> */}
                        <NewsList />
                    </div>
                    <div className={styles.conR}>
                        <SimpleSlider content={content.slider} />
                        <HotNews content={content.hotNews} />
                        <Weixin content={content.weixin} />
                    </div>
                </div>
                <Footer content={footerData} />
                <GoTop />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
